/* eslint-disable no-unused-vars */
/* eslint-disable no-const-assign */
import React, { useState, useEffect } from "react";
import "./../../../assets/css/purchase/form.css";
import DeliveryModalS from "../../components/Modal/DeliverymodalSearch";
// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import {
  formatDateOnChange,
  formatStringDateToDate,
} from "../../../utils/DateUtils";
import {
  getAlert,
  getData,
  getDataWithComp,
  getDataWithJoin,
  getSoWithoutPK,
} from "../../../utils/SamuiUtils";
import Navbar from "../../components/Modal/Navbar";

const ReceivablesReport = () => {
  // ตัวแปรเก็บชื่อหน้าจอ
  const [name, setName] = useState(null);

  // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
  const [searchCriteria, setSearchCriteria] = useState({
    docDate: null,
    dateTo: null,
  });

  // ข้อมูลที่แสดงรายงาน
  const [filteredData, setFilteredData] = useState([]);

  // สำหรับ Table รายงาน
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(16);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const [showSoModal, setShowSoModal] = useState(false);
  const handleSoShow = () => setShowSoModal(true);
  const handleSoClose = () => setShowSoModal(false);
  const [soDataList, setSoDataList] = useState([]);
  const [dlLineList, setDlLineList] = useState([]);
  const [formDetailList, setFormDetailList] = useState([]);
  const [carList, setCarList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryLineId, setDeliveryLineId] = useState(null);
  const [dlLineName, setDlLineName] = useState("");
  const [dlSelected, setDlSelected] = useState({ DL_Id: "" });
  const [arCodeFrom, setArCodeFrom] = useState("");
  const [arCodeTo, setArCodeTo] = useState("");

  useEffect(() => {
    initialize();
  }, []);

  // useEffect(() => {
  //     if (soDataList && soDataList.length > 0) {
  //         setSoDataList(soDataList);
  //     }
  // }, [soDataList]);

  // if (soDataList && soDataList.length > 0) {
  //     setSoDataList(soDataList);
  // }

  const initialize = async () => {
    // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
    setName("6.1 รายงานลูกหนี้ รายวัน");
    setFilteredData([]);
    const dlDataList = await getDataWithComp("DL_Line_H", "ORDER By DL_Id ASC");
    if (dlDataList && dlDataList.length > 0) {
      setDlLineList(dlDataList);
    }
  };

  const resetValues = () => {
    setSearchCriteria({
      docDate: null,
      dateTo: null,
    });
    setDlSelected({ DL_Id: "" });
    setArCodeFrom("");
    setArCodeTo("");
    setFilteredData([]);
    setCurrentPage(1);
    setCarList([]);
    setDriverList([]);
    setSoDataList([]);
  };

  // ฟังก์ชันที่รวม initialize และ resetValues
  const handleReset = async () => {
    resetValues();
    await initialize();
  };

  const onRowSelectDL = async (dlSelected) => {
    try {
      setIsLoading(true);
      setDlSelected(dlSelected);
      handleSoClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleChangeDate = (value, name) => {
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : "";
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const fetchCarAndDriverList = async (dlId) => {
    let findCarList;

    if (dlId) {
      findCarList = await getDataWithComp("View_DL_Car", `AND DL_Id = ${dlId}`);
    } else {
      findCarList = await getDataWithComp("Tb_Set_Car", `AND Car_Status = 'Y'`);
    }

    if (findCarList && findCarList.length > 0) {
      setCarList(findCarList);
    } else {
      setCarList([]);
    }

    const findDriverList = await getDataWithComp(
      "Tb_Set_Employee",
      `AND Emp_Status = 'Y' AND Emp_Position IN (7,8,9)`
    );
    if (findDriverList && findDriverList.length > 0) {
      setDriverList(findDriverList);
    } else {
      setDriverList([]);
    }
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);
      const formattedStartDate = searchCriteria.docDate
        ? formatStringDateToDate(searchCriteria.docDate).split(" ")[0]
        : null;
      const formattedEndDate = searchCriteria.dateTo
        ? formatStringDateToDate(searchCriteria.dateTo).split(" ")[0]
        : null;

      // 1. ถ้าไม่ใส่ ตั้งแต่วันที่ ถึงวันที่ (ให้ค้นหาหมด)
      // 2. ถ้าใส่ทั้งคู๋ ตั้งแต่วันที่ ถึงวันที่ (ให้ค้นหา Between)
      // 3. ถ้าใส่แค่ตั้งแต่วันที่ ไม่ใส่ถึงวันที่ (ให้ค้นหา Date =)
      // 4. ถ้าใส่ ถึงวันที่ ไม่ใส่ตั้งแต่วันที่ (แจ้งเตือนกรุณาระบุ ตั้งแต่วันที่)

      let date = "";
      if (formattedStartDate && formattedEndDate) {
        date += ` AND (SOH.Doc_Date BETWEEN '${formattedStartDate}' AND '${formattedEndDate}')`;
      } else if (formattedStartDate && !formattedEndDate) {
        date += ` AND SOH.Doc_Date = '${formattedStartDate}'`;
      } else if (!formattedStartDate && formattedEndDate) {
        getAlert("WARNING", "กรุณาระบุวันที่เอกสาร");
        return;
      }

      let code = "";
      if (arCodeFrom && arCodeTo) {
        code += ` AND (SOH.AR_Code BETWEEN '${arCodeFrom}' AND '${arCodeTo}')`;
      } else if (arCodeFrom && !arCodeTo) {
        code += ` AND SOH.AR_Code = '${arCodeFrom}'`;
      } else if (!arCodeFrom && arCodeTo) {
        getAlert("WARNING", "กรุณาระบุรหัสลูกหนี้");
        return;
      }

      const response = await getDataWithJoin(
        `SOH.Doc_ID,
                 SOH.Doc_Date,
                 SOH.Doc_No,
                 SOH.AR_Code,
                 SOH.AR_Name,
                 SOH.NetTotal,
                 c.DL_LineName,
                 c.DL_Id,
                 SUM(d.Item_Qty) AS Item_Qty
                `,
        `API_0701_SO_H AS SOH`,
        `
                LEFT JOIN API_0801_PKList_H AS PK ON ( SOH.Doc_Is_PickingList = PK.Doc_Id )
                LEFT JOIN DL_Line_H AS c ON ( PK.Delivery_Line_Id = c.DL_Id )
                LEFT JOIN API_0702_SO_D AS d ON ( SOH.Doc_Is_PickingList = d.Doc_ID ) 
                WHERE
                SOH.Doc_Is_PickingList <> 0 ${date} ${code} AND SOH.Comp_Id = ${window.localStorage.getItem(
          "company"
        )}
                ${dlSelected?.DL_Id ? `AND c.DL_Id = ${dlSelected?.DL_Id}` : ""}
                `,
        `
                GROUP BY
                    SOH.Doc_ID,
                    SOH.Doc_Date,
                    SOH.Doc_No,
                    SOH.AR_Code,
                    SOH.AR_Name,
                    SOH.NetTotal,
                    c.DL_LineName,
                    c.DL_Id
                ORDER BY SOH.Doc_Date DESC
        `
      );

      if (response && response.length > 0) {
        setFilteredData(response);
      } else {
        setFilteredData([]);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  return (
    <>
      <Navbar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/receivables-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <form className="row">
                      <div className="col-auto">
                        <label htmlFor="docDate" className="form-label">
                          วันที่เอกสาร
                        </label>
                        <Datetime
                          id="docDate"
                          className="input-spacing-input-date"
                          value={searchCriteria.docDate}
                          key={searchCriteria.docDate}
                          dateFormat="DD-MM-YYYY"
                          timeFormat={false}
                          onChange={(date) => handleChangeDate(date, "docDate")}
                          inputProps={{ readOnly: true, disabled: false }}
                        />
                      </div>
                      <div className="col-auto">
                        <label htmlFor="dateTo" className="form-label">
                          ถึง
                        </label>
                        <Datetime
                          id="dateTo"
                          className="input-spacing-input-date"
                          value={searchCriteria.dateTo}
                          key={searchCriteria.dateTo}
                          dateFormat="DD-MM-YYYY"
                          timeFormat={false}
                          onChange={(date) => handleChangeDate(date, "dateTo")}
                          inputProps={{ readOnly: true, disabled: false }}
                        />
                      </div>

                      <div className="col-auto">
                        <label className="form-label">รหัสลูกหนี้</label>
                        <input
                          type="text"
                          className="form-control"
                          value={arCodeFrom}
                          onChange={(e) => setArCodeFrom(e.target.value)}
                        />
                      </div>

                      <div className="col-auto">
                        <label className="form-label">ถึง</label>
                        <input
                          type="text"
                          className="form-control"
                          value={arCodeTo}
                          onChange={(e) => setArCodeTo(e.target.value)}
                        />
                      </div>

                      <div className="col-auto">
                        <label className="form-label">สายรถ</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-spacing"
                            name="apCode"
                            value={dlSelected?.DL_LineName || ""}
                            disabled={true}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleSoShow();
                            }}
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>

                      <div className="col-md-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            marginRight: "20px",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => handleSearch()}
                        >
                          <i className="fas fa-search" /> ค้นหา
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            width: "10%",
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                          }}
                          onClick={() => resetValues()}
                        >
                          <i className="fas fa-undo" /> เริ่มใหม่
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <DeliveryModalS
                showSoModal={showSoModal}
                handleSoClose={handleSoClose}
                soDataList={soDataList}
                dlLineList={dlLineList}
                onRowSelectDL={onRowSelectDL}
              />
              {/* ReportsTable */}
              <ReportsTable
                currentItems={currentItems}
                currentPage={currentPage}
                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                dataMasterList={filteredData}
                itemsPerPage={itemsPerPage}
                fieldMappings={{
                  docDate: "Doc_Date",
                  docNo: "Doc_No",
                  arCode: "AR_Code",
                  arName: "AR_Name",
                  netTotal: "NetTotal",
                  dLLineName: "DL_LineName",
                  itemQty: "Item_Qty",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReceivablesReport;
